"use client";

import { FeaturedBanners } from "@/components/feature/featured-banners/featured-banners";

export function FeaturedBannersWrapper() {
  return <FeaturedBanners className="pb-4 pt-0" />;
}
